let defaultForm = {
  business_license_info: {
    business_time: [],
  },
  finance_institution_info: {},
  id_card_info: {},
  id_doc_info: {},
  account_info: {},
  contact_info: {},
  sales_scene_info: {},
  settlement_info: {},
  ubo_info_list: {},
};
export default {
  namespaced: true,
  state: {
    form: {
      business_license_info: {
        business_time: [],
      },
      finance_institution_info: {},
      id_card_info: {},
      id_doc_info: {},
      account_info: {},
      contact_info: {},
      sales_scene_info: {},
      settlement_info: {},
      ubo_info_list: {},
    },
    merchantStep: "",
  },
  getters: {
    form: (state: any) => {
      // 从localStorage中获取form
      state.form = JSON.parse(
        localStorage.getItem("MERCHANTFORM") || JSON.stringify(defaultForm)
      );
      return state.form;
    },
    merchantStep: (state: any) => {
      state.merchantStep = localStorage.getItem("MERCHANTSTEP") || "";
      return state.merchantStep;
    },
  },
  mutations: {
    SET_FORM(state: any, form: any) {
      state.form = form;
      // 将form存储到localStorage中
      localStorage.setItem("MERCHANTFORM", JSON.stringify(state.form));
    },
    CLEAR_FORM(state: any) {
      state.form = defaultForm;
      // 清除localStorage中的form
      localStorage.removeItem("MERCHANTFORM");
    },
    RESET_FORM(state: any) {
      console.log(state.form, "RESET_FORM");
      let out_request_no = state.form.out_request_no
        ? state.form.out_request_no
        : "";
      state.form = defaultForm;
      // 清除localStorage中的form
      localStorage.removeItem("MERCHANTFORM");
      if (out_request_no) {
        state.form.out_request_no = out_request_no;
        localStorage.setItem("MERCHANTFORM", JSON.stringify(state.form));
      }
    },
    SET_MERCHANTSTEP(state: any, step: any) {
      state.merchantStep = step;
      // 将step存储到localStorage中
      localStorage.setItem("MERCHANTSTEP", state.merchantStep);
    },
    CLEAR_MERCHANTSTEP(state: any) {
      state.merchantStep = 1;
      // 清除localStorage中的step
      localStorage.removeItem("MERCHANTSTEP");
    },
  },
  // 异步的方法
  actions: {
    changeForm({ commit }: any, payload: any) {
      commit("SET_FORM", payload);
    },
    clearForm({ commit }: any) {
      commit("CLEAR_FORM");
    },
    changeMerchantStep({ commit }: any, payload: any) {
      commit("SET_MERCHANTSTEP", payload);
    },
    clearMerchantStep({ commit }: any) {
      commit("CLEAR_MERCHANTSTEP");
    },
    resetForm({ commit }: any) {
      commit("RESET_FORM");
    },
  },
};
